function changeLanguageText(lang) {
  console.log('Current language:', lang);
  const container = document.querySelector('.faq-banner-container');
  if (container) {
    const textContainer = container.querySelector('.faq-banner-text');
    if (textContainer) {
      let newText = '';
      if (lang === 'spain') {
        newText = container.getAttribute('data-heading-spain') || '';
      } else if (lang === 'de') {
        newText = container.getAttribute('data-heading-de') || '';
      } else if (lang === 'en') {
        newText = container.getAttribute('data-heading-en') || '';
      } else if (lang === 'nl') {
        newText = container.getAttribute('data-heading-nl') || '';
      } else if (lang === 'it' || lang === 'it-it') {
        newText = container.getAttribute('data-heading-it') || '';
      } else if (lang === 'fr') {
        newText = container.getAttribute('data-heading-fr') || '';
      } else if (lang === 'sweden') {
        newText = container.getAttribute('data-heading-sweden') || '';
      } else if (lang === 'iceland') {
        newText = container.getAttribute('data-heading-iceland') || '';
      }
      
      if (newText && newText.trim() !== '') {
        try {
          let decoded = decodeURIComponent(newText.replace(/\+/g, '%20'));
          // Injecting a wrapper class that acts like the h1 so richtext <p> is styled properly
          textContainer.innerHTML = '<div class="custom-lang-heading" style="font-family: \'Chromatic Pro Bold\', sans-serif; font-weight: 700; font-size: 56px; line-height: 100%; color: #FFFFFF; text-transform: uppercase;">' + decoded + '</div>';
        } catch(e) {
          textContainer.innerHTML = '<h1 style="color:red; font-size:40px;">Error decoding text</h1>';
        }
      } else {
        // Visual feedback if the field is empty in CMS
        textContainer.innerHTML = '<h1 style="color:red; font-size:40px;">(Please add text for ' + lang.toUpperCase() + ' in CMS)</h1>';
      }
    }
  }

  // Map Header Update
  const mapHeader = document.querySelector('.liv-map-header');
  if (mapHeader) {
    const mapHeading = mapHeader.querySelector('h2');
    const mapSubheading = mapHeader.querySelector('p');
    if (mapHeading) {
      let newMapText = '';
      let newSubheading = '';
      if (lang === 'spain') {
        newMapText = mapHeader.getAttribute('data-heading-spain') || '';
        newSubheading = mapHeader.getAttribute('data-subheading-spain') || '';

      } else if (lang === 'de') {
        newMapText = mapHeader.getAttribute('data-heading-de') || '';
        newSubheading = mapHeader.getAttribute('data-subheading-de') || '';

      } else if (lang === 'en') {
        newMapText = mapHeader.getAttribute('data-heading-en') || '';
        newSubheading = mapHeader.getAttribute('data-subheading-en') || '';

      } else if (lang === 'nl') {
        newMapText = mapHeader.getAttribute('data-heading-nl') || '';
        newSubheading = mapHeader.getAttribute('data-subheading-nl') || '';

      } else if (lang === 'it' || lang === 'it-it') {
        newMapText = mapHeader.getAttribute('data-heading-it') || '';
        newSubheading = mapHeader.getAttribute('data-subheading-it') || '';
      } else if (lang === 'fr') {
        newMapText = mapHeader.getAttribute('data-heading-fr') || '';
        newSubheading = mapHeader.getAttribute('data-subheading-fr') || '';
      } else if (lang === 'sweden') {
        newMapText = mapHeader.getAttribute('data-heading-sweden') || '';
        newSubheading = mapHeader.getAttribute('data-subheading-sweden') || '';
      } else if (lang === 'iceland') {
        newMapText = mapHeader.getAttribute('data-heading-iceland') || '';
        newSubheading = mapHeader.getAttribute('data-subheading-iceland') || '';
      }
      if (newMapText.trim() !== '') {
        mapHeading.innerText = newMapText;
      }
      if (mapSubheading && newSubheading.trim() !== '') {
        mapSubheading.innerText = newSubheading;
      }
    }
  }
}